import {Button, ButtonGroup, FormControl, FormHelperText, TextField} from '@material-ui/core';
import 'Agent/AgentForms/Marketing/components/MarketingViewCart.sass';
import 'Agent/AgentForms/Marketing/components/SearchForm.sass';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {getNameFromClaims} from 'Shared/components/nameFormatter';
import {isUserEmulating} from 'Shared/utilities/impersonationHelpers';
import {
  cartDataCopyHandlerViewCartYourInfo,
  changeViewCart,
  dispatchChangeHandler,
  RequiredCheckoutCartFields,
  shipToSelfHandler,
  shipToSomeoneElseHandler,
} from '../ducks/Marketing';
import CostCenterInput from './CostCenterInput';

const ViewCartYourInfo = () => {
  const userClaimsState = useSelector((state: ReducerState) => state.user.profile.userClaims);
  const {isShippingToSelf, viewCart, missingRequiredFields, costCenters} = useSelector(
    (state: ReducerState) => state.marketing
  );

  const nameInfo = getNameFromClaims(userClaimsState);
  const dispatch = useDispatch();
  const [cartDataCopy, setCartDataCopy] = useState({...viewCart});
  const isImpersonating = isUserEmulating(userClaimsState);

  const setHandler = cartDataCopyHandlerViewCartYourInfo(setCartDataCopy, cartDataCopy);

  useEffect(() => {
    if (!viewCart.firstName || viewCart.firstName.length < 1) {
      cartDataCopy.firstName = nameInfo._tag === 'Some' ? nameInfo.value.firstName : '';
      setCartDataCopy({...cartDataCopy});
      dispatch(changeViewCart({...cartDataCopy}));
    }
    if (!viewCart.lastName || viewCart.lastName.length < 1) {
      cartDataCopy.lastName = nameInfo._tag === 'Some' ? nameInfo.value.lastName : '';
      setCartDataCopy({...cartDataCopy});
      dispatch(changeViewCart({...cartDataCopy}));
    }
  }, []);

  useEffect(() => {
    dispatch(changeViewCart({...cartDataCopy}));
  }, [cartDataCopy.isShippingToSelf]);

  const handleShipToSomeoneElse = shipToSomeoneElseHandler(
    isImpersonating,
    setCartDataCopy,
    cartDataCopy,
    dispatch,
    missingRequiredFields
  );
  const handleShipToSelf = shipToSelfHandler(
    cartDataCopy,
    nameInfo,
    isImpersonating,
    setCartDataCopy,
    dispatch,
    missingRequiredFields
  );
  const dispatchChange = dispatchChangeHandler(setCartDataCopy, cartDataCopy, dispatch);

  return (
    <div style={{width: '90%', marginLeft: '1rem'}}>
      <FormControl fullWidth={true}>
        <FormHelperText style={{fontSize: '1rem', color: '#0033a0'}}>
          Who are you shipping to: {isShippingToSelf ? 'SELF' : 'SOMEONE ELSE'}
        </FormHelperText>
      </FormControl>
      <ButtonGroup
        color="primary"
        aria-label="shipping to"
        className="button-section field-section-account"
        fullWidth={true}
        style={{border: '1px solid #004ea8', borderRadius: '6px'}}
      >
        <Button
          color="primary"
          variant="contained"
          disabled={isShippingToSelf}
          onClick={handleShipToSelf}
        >
          {' '}
          Ship to self
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={!isShippingToSelf}
          onClick={handleShipToSomeoneElse}
        >
          {' '}
          Ship to someone else
        </Button>
      </ButtonGroup>
      <FormControl className="field-section-account" fullWidth={true}>
        <TextField
          variant="outlined"
          label="Company"
          placeholder="Company"
          size="small"
          name="company"
          value={cartDataCopy.company}
          onChange={e => setHandler(e)}
          onBlur={e => dispatchChange()}
        />
      </FormControl>
      <div className="flex-container" style={{margin: '1rem 0rem 0 0rem'}}>
        <FormControl className="flex-item-left">
          <TextField
            variant="outlined"
            label={
              missingRequiredFields.includes(RequiredCheckoutCartFields.FIRST_NAME) && cartDataCopy.firstName === ''
                ? 'First Name is required'
                : 'First Name'
            }
            size="small"
            placeholder="First Name"
            name="firstName"
            error={
              missingRequiredFields.includes(RequiredCheckoutCartFields.FIRST_NAME) && cartDataCopy.firstName === ''
            }
            value={cartDataCopy.firstName}
            onChange={e => setHandler(e)}
            onBlur={e => dispatchChange()}
          />
        </FormControl>
        <div className="flex-item-middle"></div>
        <FormControl className="flex-item-right">
          <TextField
            variant="outlined"
            label={
              missingRequiredFields.includes(RequiredCheckoutCartFields.LAST_NAME) && cartDataCopy.lastName === ''
                ? 'Last Name is required'
                : 'Last Name'
            }
            size="small"
            placeholder="Last Name"
            name="lastName"
            error={missingRequiredFields.includes(RequiredCheckoutCartFields.LAST_NAME) && cartDataCopy.lastName === ''}
            value={cartDataCopy.lastName}
            onBlur={e => dispatchChange()}
            onChange={e => setHandler(e)}
          />
        </FormControl>
      </div>
      <FormControl className="field-section-account" fullWidth={true}>
        <TextField
          variant="outlined"
          label="Account Name / Number"
          size="small"
          placeholder="Account Name / Number"
          name="accountNumber"
          value={cartDataCopy.accountNumber}
          onChange={e => setHandler(e)}
          onBlur={e => dispatchChange()}
        />
      </FormControl>
      <FormHelperText style={{color: '#0033a0', marginBottom: '1rem'}}>
        If you are ordering supplies for specific Accounts.
      </FormHelperText>

      {isImpersonating && (
        <FormControl className="field-section-cost-center" fullWidth={true}>
          <CostCenterInput dispatchChange={dispatchChange} setHandler={setHandler} />
        </FormControl>
      )}
    </div>
  );
};

export default ViewCartYourInfo;
